import {Component} from 'react';

export default class DataAbstract extends Component {
    // constructor(props) {
    //     super(props);
    // }
}


// WEBPACK FOOTER //
// ./src/data/DataAbstract.js